import type { Vec3Data } from '@/entities/model3d'

export const roundAbsolute = (value: number) => Math.round(Math.abs(value) * 100)

export const roundTo = (value: number, to: number) => (value < 0 ? Math.floor(value / to) : Math.ceil(value / to)) * to

export const compareVec3 = (current: Vec3Data, target: Vec3Data): boolean =>
  Math.abs(current.x - target.x) < 0.0001 && Math.abs(current.y - target.y) < 0.0001 && Math.abs(current.z - target.z) < 0.0001
